module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/campaign-two-ed6a210f2ab28dbc69bcf532f4f6ee57.png";